const TRANSACTION_METHODS_MAP = {
  PosCard: {
    value: "pos_card",
    label: "Card",
  },
  PosCash: {
    value: "pos_cash",
    label: "Cash",
  },
} as const satisfies OptionsMap

const _options = buildOptionsFromMap(
  TRANSACTION_METHODS_MAP
)

export const useTransactionMethodOptions = () => ({
  options: _options,
  getLabelForValue: (value: TransactionMethod) =>
    computed(
      () =>
        _options.find((option) => option.value === value)
          ?.label || ""
    ),
})
